import React from 'react';
import OrderCards from './orderCards';
import { FaSearch } from 'react-icons/fa';
const orders = [
    {
        image: "/images/card-3.jpeg",
        title: "Lorem ipsum dolor.",
        price: 150,
        steps: ['Ordered', 'Confirmation', 'Shipping', 'Delivery'],
    },
    {
        image: "/images/card-3.jpeg",
        title: "Lorem ipsum dolor.",
        price: 150,
        steps: ['Ordered', 'Confirmation', 'Shipping', 'Delivery'],
    },
    {
        image: "/images/card-3.jpeg",
        title: "Lorem ipsum dolor.",
        price: 150,
        steps: ['Ordered', 'Confirmation', 'Shipping', 'Delivery'],
    },
    {
        image: "/images/card-3.jpeg",
        title: "Lorem ipsum dolor.",
        price: 150,
        steps: ['Ordered', 'Confirmation', 'Shipping', 'Delivery'],
    },
    // ... more orders
];

const Orders = () => {
    return (
        <div className="">
            <div className="orders-search-wrapper mb-4 position-relative mx-auto">
                <input
                    type="text"
                    placeholder="Search for Orders"
                    className="form-control rounded-pill shadow-sm py-3 px-4 search_bar_profile"
                />
                <FaSearch className="orders-search-icon" />
            </div>
            <div className='card_wrapper pe-1'>
                {orders.map((order, i) => (
                    <OrderCards key={i} order={order} currentStep={2} />
                ))}
            </div>
        </div>
    )
}

export default Orders